import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const testimonialsContainer = el.querySelector(".testimonials-slider");
  const testimonialsSlider = testimonialsContainer.querySelector(".testimonials-slider .swiper-container");

  if (!testimonialsSlider) {
    return;
  }

  new Swiper(testimonialsSlider, {
    modules: [A11y, Autoplay, EffectFade, Navigation, Pagination],
    autoplay: {
      delay: 3000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: testimonialsContainer.querySelector(".slider-pagination"),
      clickable: true,
    },
    autoplay: false,
  });
});